import { render, staticRenderFns } from "./CatalogList.vue?vue&type=template&id=26706dc5&"
import script from "./CatalogList.vue?vue&type=script&lang=ts&"
export * from "./CatalogList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports